<template>
  <div id="archive">
    <header>
        <HeaderWhite/>
    </header>
    <main class="archive-list-area">
        <span class="title_caption title font__roboto">ARCHIVE</span>
        <div  class="archive-list-block">
          <ArchiveList
              v-for="archiveData in archiveListAll"
              :key="archiveData.id"
              :eventDate="archiveData.event_date"
              :id="archiveData.id"
              :title="archiveData.title"
              :archiveA="archiveData.detail_a"
              :archiveB="archiveData.detail_b"
              :archiveC="archiveData.detail_c"
              :tirasiName="archiveData.tirasi_name"
              :linkName="archiveData.link_name"
              :linkUrl="archiveData.link_url"
            />
        </div>
    </main>
    <footer>
      <Footer/>
    </footer>
  </div>
</template>

<script>
import axios from 'axios'
import HeaderWhite from '@/components/common/HeaderWhite.vue'
import ArchiveList from '@/components/hiyamizu/ArchiveList.vue'
import Footer from '../components/common/Footer.vue'

export default {
  name: 'archive',
  components: {
    HeaderWhite,
    Footer,
    ArchiveList
  },
  data() {
    return {
        archiveListAll: {},
    }
  },
  //axiosによるデータ取得処理
  mounted () {
    // アーカイブデータ取得
    axios.get('https://yamadashimpei.com:9876/archive_api')
    .then((response) => {
      this.archiveListAll = response.data.response;
    })
},
}
</script>
<style lang="scss" scoped>
  .title_caption {
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    margin-bottom: 20px;
    display: inline-block;
    line-height: normal;
    font-size: 18px;
    border-bottom: solid 1px #000000;
    margin-bottom: 40px;
  }

.archive-list-area {
    margin: 0 auto;
    margin-top: 80px;
    margin-bottom: 60px;
}
// .title {
//   position: relative;
//   left: 50%;
//   transform: translateX(-50%);
//   margin-bottom: 20px;
//   font-size: 8vw;
// }

// PC
@media screen and (min-width: 768px) {
  .title_caption { 
    font-size: 22px;
    margin-bottom: 72px;
  }
  .archive-list-area {
    width: 60vw;
    max-width: 1500px;
  }
  .archive-list-block {
    margin-bottom: 100px;
  }
}
</style>